import React, { useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import styles from "./Popup.module.css";
import stylee from "./verify.module.css";
import { AiOutlineClose } from "react-icons/ai";
import { Link } from "react-router-dom";
import axios from "axios";
import profile1 from "../../assets/User-avatar.png";
import Swal from "sweetalert2";
import { apiBaseURL } from "../../utils/axios";
import { TextField, MenuItem } from "@mui/material";
import { countries } from "../_mock/_countries";
import { ImSpinner } from "react-icons/im";
import nigeriaStates from "../../pages/auth/nigeriaStates.json";

const genderType = [
  {
    value: "Male",
    label: "Male",
  },
  {
    value: "Female",
    label: "Female",
  },
];

const pintBlood = [
  {
    value: 1,
    label: "one",
  },
  {
    value: 2,
    label: "two",
  },
];

const bloodSample = [
  {
    value: "A",
    label: "A",
  },
  {
    value: "A-",
    label: "A-",
  },
  {
    value: "A+",
    label: "A+",
  },
  {
    value: "B",
    label: "B",
  },
  {
    value: "B-",
    label: "B-",
  },
  {
    value: "B+",
    label: "B+",
  },
  {
    value: "AB",
    label: "AB",
  },
  {
    value: "AB-",
    label: "AB-",
  },
  {
    value: "AB+",
    label: "AB+",
  },
  {
    value: "O",
    label: "O",
  },
  {
    value: "O-",
    label: "O-",
  },
  {
    value: "O+",
    label: "O+",
  },
];

const Popup = (props) => {
  let donor = props.donor;

  const navigate = useNavigate();
  const [open, setOpen] = useState(false);
  const { id } = useParams();
  const [firstName, setFirstName] = useState("");
  const [lastName, setLastName] = useState("");
  const [gender, setGender] = useState("");
  const [age, setAge] = useState("");
  const [phone, setPhone] = useState("");
  const [bloodType, setBloodType] = useState("");
  const [ailmentDiagnosis, setAilmentDiagnosis] = useState("");
  const [country, setCountry] = useState("");
  const [state, setState] = useState("");
  const [city, setCity] = useState("");
  const [email, setEmail] = useState("");
  const [patientLocation, setPatientLocation] = useState("");
  const [pintOfBlood, setPintOfBlood] = useState("");
  const [isLoading, setIsLoading] = useState(false);

  const handleRequestClose = () => {
    props.onClose();
    navigate("/need-blood");
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    setIsLoading(true);

    const patientRequestData = {
      firstname: firstName,
      lastname: lastName,
      gender,
      age,
      phone,
      bloodType,
      ailmentDiagnosis,
      country,
      state,
      city,
      email,
      patientLocation,
      pintOfBlood,
    };
    // console.log(patientRequestData);

    axios({
      method: "post",
      url: `${apiBaseURL}/v1/patients?donorId=${id}`,
      data: patientRequestData,
    })
      .then((response) => {
        // console.log(response);
        // console.log(response.data.name);
        setIsLoading(false);
        Swal.fire({
          icon: "success",
          title: "Request Successful",
          text: response.data.msg,
        });
        return setOpen(true);
      })
      .catch((error) => {
        // handleClose();
        console.error(error);
        setIsLoading(false);
        return Swal.fire({
          icon: "error",
          title: "Oops...",
          text: error.response.data,
        });
      });
  };

  if (!props.show) {
    return null;
  }

  return (
    <>
      <div className={styles.modal} onClick={props.onClose}>
        <div className={styles.scroll}>
          <div className={styles.popModal} onClick={(e) => e.stopPropagation()}>
            <div className={styles.modalClose}>
              <button
                className="close-modal-bttn"
                style={{
                  cursor: "pointer",
                  backgroundColor: "transparent",
                  border: "none",
                }}
                onClick={props.onClose}
              >
                <AiOutlineClose color="white" size={30} />
              </button>
            </div>
            {/* <h6 className={styles.topText}>
              If you have already filled before, kindly fill again with the same
              details. Thanks
            </h6> */}
            <form className={styles.formHolder} onSubmit={handleSubmit}>
              <p className={`${styles.chooseTimeDate} text-lg md:text-xl`}>
                Kindly fill the donor request form
              </p>
              {/*  <div
                className={`text-white flex flex-col sm:flex-row sm:space-x-3 justify-center`}
              >
                <LocalizationProvider dateAdapter={AdapterDayjs}>
                  <DemoContainer components={["DatePicker"]}>
                    <DatePicker
                      value={dayjs(date)}
                      onChange={(date) => setDate(date)}
                    />
                  </DemoContainer>
                </LocalizationProvider>

                <LocalizationProvider dateAdapter={AdapterDayjs}>
                  <DemoContainer components={["TimePicker"]}>
                    <TimePicker
                      className="text-white"
                      value={dayjs(time)}
                      onChange={(time) => setTime(time)}
                    />
                  </DemoContainer>
                </LocalizationProvider>
              </div>
              <div className="border my-5 opacity-25"></div> */}
              <>
                <TextField
                  sx={{
                    width: "100%",
                    marginTop: "20px",
                  }}
                  label="First Name"
                  variant="outlined"
                  value={firstName}
                  required
                  onChange={(e) => {
                    setFirstName(e.target.value);
                  }}
                />

                <TextField
                  sx={{
                    width: "100%",
                    marginTop: "20px",
                  }}
                  label="Last Name"
                  variant="outlined"
                  value={lastName}
                  required
                  onChange={(e) => {
                    setLastName(e.target.value);
                  }}
                />

                <TextField
                  sx={{
                    width: "100%",
                    color: "white",
                    marginTop: "20px",
                  }}
                  select
                  label="Gender"
                  value={gender}
                  onChange={(e) => {
                    setGender(e.target.value);
                  }}
                  required
                >
                  {genderType.map((option) => (
                    <MenuItem key={option.value} value={option.value}>
                      {option.label}
                    </MenuItem>
                  ))}
                </TextField>

                <TextField
                  sx={{
                    width: "100%",
                    marginTop: "20px",
                  }}
                  label="Age"
                  variant="outlined"
                  value={age}
                  required
                  onChange={(e) => {
                    setAge(e.target.value);
                  }}
                />

                <TextField
                  sx={{
                    width: "100%",
                    marginTop: "20px",
                  }}
                  label="Phone Number"
                  variant="outlined"
                  value={phone}
                  required
                  onChange={(e) => {
                    setPhone(e.target.value);
                  }}
                />

                <TextField
                  sx={{
                    width: "100%",
                    marginTop: "20px",
                  }}
                  select
                  label="Blood Type"
                  value={bloodType}
                  onChange={(e) => setBloodType(e.target.value)}
                  required
                >
                  {bloodSample.map((option) => (
                    <MenuItem key={option.value} value={option.value}>
                      {option.label}
                    </MenuItem>
                  ))}
                </TextField>

                <TextField
                  sx={{
                    width: "100%",
                    marginTop: "20px",
                  }}
                  label="Ailment Diagnosis (Sickness)"
                  variant="outlined"
                  value={ailmentDiagnosis}
                  required
                  onChange={(e) => {
                    setAilmentDiagnosis(e.target.value);
                  }}
                />

                <TextField
                  sx={{
                    width: "100%",
                    marginTop: "20px",
                  }}
                  select
                  defaultValue=""
                  label="Country"
                  variant="outlined"
                  value={country}
                  onChange={(e) => setCountry(e.target.value)}
                  required
                >
                  {countries.map((option) => (
                    <MenuItem key={option.code} value={option.label}>
                      {option.label}
                    </MenuItem>
                  ))}
                </TextField>

                {/* State */}
                <TextField
                  sx={{
                    width: "100%",
                    marginTop: "20px",
                  }}
                  select
                  defaultValue=""
                  label="State"
                  variant="outlined"
                  value={state}
                  onChange={(e) => setState(e.target.value)}
                  required
                >
                  {nigeriaStates.map((option) => (
                    <MenuItem key={option.id} value={option.name}>
                      {option.name}
                    </MenuItem>
                  ))}
                </TextField>
                {/* State */}

                {/* <TextField
                  sx={{
                    width: "100%",
                    marginTop: "20px",
                  }}
                  label="State"
                  variant="outlined"
                  value={state}
                  required
                  onChange={(e) => {
                    setState(e.target.value);
                  }}
                /> */}

                <TextField
                  sx={{
                    width: "100%",
                    marginTop: "20px",
                  }}
                  label="City/Town"
                  variant="outlined"
                  value={city}
                  required
                  onChange={(e) => {
                    setCity(e.target.value);
                  }}
                />

                <TextField
                  sx={{
                    width: "100%",
                    marginTop: "20px",
                  }}
                  label="Email"
                  variant="outlined"
                  value={email}
                  required
                  onChange={(e) => {
                    setEmail(e.target.value);
                  }}
                />

                <TextField
                  sx={{
                    width: "100%",
                    marginTop: "20px",
                  }}
                  label="Hospital Address"
                  variant="outlined"
                  value={patientLocation}
                  required
                  onChange={(e) => {
                    setPatientLocation(e.target.value);
                  }}
                />

                {/* <TextField
                  sx={{
                    width: "100%",
                    marginTop: "20px",
                  }}
                  label="Pint of Blood"
                  variant="outlined"
                  value={pintOfBlood}
                  required
                  onChange={(e) => {
                    setPintOfBlood(e.target.value);
                  }}
                /> */}
                {/* PintOfBlood */}
                <TextField
                  sx={{
                    width: "100%",
                    color: "white",
                    marginTop: "20px",
                  }}
                  select
                  label="Pint of Blood"
                  value={pintOfBlood}
                  onChange={(e) => {
                    setPintOfBlood(e.target.value);
                  }}
                  required
                >
                  {pintBlood.map((option) => (
                    <MenuItem key={option.label} value={option.value}>
                      {option.value}
                    </MenuItem>
                  ))}
                </TextField>
              </>

              <div className={styles.buttonWrap}>
                {isLoading ? (
                  <button className="font-bold cursor-not-allowed w-full py-2 px-8 text-[13px] rounded-full flex items-center justify-center border-[1.5px] bg-gray-500 text-gray-300">
                    <ImSpinner className="animate-spin mr-2" size={24} />{" "}
                    Submitting...
                  </button>
                ) : (
                  <>
                    <button
                      type="submit"
                      className="font-bold mx-3 cursor-pointer py-2 px-8 text-[13px] rounded-full border-white border-[1.5px] hover:bg-red-400 bg-[#f6655f] text-white"
                      // onClick={handleSubmit}
                    >
                      Confirm
                    </button>
                    <button
                      onClick={props.onClose}
                      className={styles.cancelButton}
                    >
                      Cancel
                    </button>
                  </>
                )}
              </div>
            </form>
            <div style={{ marginTop: 20, marginBottom: 20 }}>
              <p className={styles.tandc}>
                By clicking confirm, you agree to our{" "}
                <Link to="/privacy" style={{ textDecoration: "underline" }}>
                  User Agreement
                </Link>
                . Learn how we collect, use and share your data in our{" "}
                <Link to="/privacy" style={{ textDecoration: "underline" }}>
                  Privacy Policy
                </Link>
              </p>
            </div>
          </div>
        </div>
      </div>
      {open && (
        <div
          className="fixed w-screen h-screen z-[100] top-0 left-0 bottom-0 right-0 overflow-x-hidden overflow-y-hidden bg-[#f2f2f2cc] font-poppins"
          tabIndex="-1"
          onClick={(e) => e.stopPropagation()}
        >
          <div className="rounded-lg w-4/5 lg:w-3/5 relative my-40 lg:my-[112px] mx-auto p-5 bg-[#f6655f] text-current">
            <div className="">
              <div className={stylee.modalClose}>
                <button
                  type="button"
                  className="btn-close box-content"
                  onClick={props.onClose}
                  style={{
                    backgroundColor: "transparent",
                    border: "none",
                    cursor: "pointer",
                  }}
                >
                  <AiOutlineClose color="white" size={32} />
                </button>
              </div>
              <div className={stylee.wrapper}>
                <p className={stylee.title}>Donor Information</p>
                <div className="" style={{ display: "grid" }}>
                  <img
                    className={stylee.img}
                    src={donor.avater ? donor.avater : profile1}
                    alt="donor holder"
                    onError={(event) => {
                      event.target.src =
                        "https://180dc.org/wp-content/uploads/2022/04/Blank-Avatar-300x262.png";
                      event.onerror = null;
                    }}
                  />
                </div>
                <div className={stylee.detailWrap}>
                  <div className={stylee.donorDetail}>
                    <p className={stylee.detailText}>First name:</p>
                    <p
                      className={`${styles.detailText} first-letter:uppercase`}
                    >
                      {donor.firstname}
                    </p>
                    <p className={stylee.detailText}>Last name:</p>
                    <p
                      className={`${styles.detailText} first-letter:uppercase`}
                    >
                      {donor.lastname}
                    </p>
                    <p className={stylee.detailText}>Gender:</p>
                    <p
                      className={`${stylee.detailText} first-letter:uppercase`}
                    >
                      {donor.gender}
                    </p>
                    <p className={stylee.detailText}>Phone number:</p>
                    <p className={stylee.detailText}>{donor.phone}</p>
                    <p className={stylee.detailText}>Blood Type:</p>
                    <p className={stylee.detailText}>{donor.bloodType}</p>
                    <p className={stylee.detailText}>Country:</p>
                    <p
                      className={`${styles.detailText} first-letter:uppercase`}
                    >
                      {donor.country}
                    </p>
                    <p className={stylee.detailText}>State:</p>
                    <p
                      className={`${styles.detailText} first-letter:uppercase`}
                    >
                      {donor.state}
                    </p>
                    <p className={stylee.detailText}>City/Town:</p>
                    <p
                      className={`${styles.detailText} first-letter:uppercase`}
                    >
                      {donor.city}
                    </p>
                  </div>
                </div>
                <div
                  className="barLine"
                  style={{
                    border: 6,
                    color: "red",
                    margin: "10px auto",
                    opacity: 0.25,
                  }}
                ></div>
                <div
                  className=""
                  style={{ margin: "20px 0px", textAlign: "center" }}
                >
                  <button
                    type="button"
                    className={`${stylee.button} transition duration-150 ease-in-out`}
                    data-bs-dismiss="modal"
                    onClick={handleRequestClose}
                  >
                    Close
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
};
export default Popup;
